import { useYouHeader } from '../YouHeaderContext/YouHeaderContext';

const YouFooterActions = () => {
  const { footer } = useYouHeader();
  if (!footer) return null;
  return <div data-testid="footer-actions">{footer}</div>;
};

export { YouFooterActions };
